import { render, staticRenderFns } from "./Weigh.vue?vue&type=template&id=710ab375&scoped=true&"
import script from "./Weigh.vue?vue&type=script&lang=js&"
export * from "./Weigh.vue?vue&type=script&lang=js&"
import style0 from "./Weigh.vue?vue&type=style&index=0&id=710ab375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ab375",
  null
  
)

export default component.exports